import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

import App from "App";
import {
  ExpiredLinkPage,
  LoginPage,
  MaskSetPasswordPage,
  SetPasswordPage,
  NotLogged404Page,
  RegisterPage,
  VerifyEmailPage,
  ResetPasswordPage,
  VerifyEmailResetPasswordPage,
  Account,
} from "pages";
import {
  BackgroundLayout,
  NotFoundComponent,
  ProtectedRoute,
} from "components";
import {
  ProfilePage,
  ProjectsPage,
  SourcesPage,
  DetailProjectPage,
  TopicsPage,
  UsersPage,
  CheckProjectShareCodePage,
} from "pages/account/pages";
import { ReportsPage } from "pages/account/pages/ReportsPage/ReportsPage";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="*" element={<App />}>
      <Route
        path=""
        element={
          <ProtectedRoute logged={false}>
            <BackgroundLayout />
          </ProtectedRoute>
        }
      >
        <Route path="" element={<LoginPage />} />
        <Route path="register" element={<RegisterPage />} />
        <Route path="verify-email" element={<VerifyEmailPage />} />
        <Route
          path="verify-email-reset-password"
          element={<VerifyEmailResetPasswordPage />}
        />
        <Route path="check-token" element={<MaskSetPasswordPage />} />
        <Route
          path="check-token-reset-password"
          element={<MaskSetPasswordPage />}
        />
        <Route path="expired-link" element={<ExpiredLinkPage />} />
        <Route path="not-logged-found" element={<NotLogged404Page />} />
        <Route path="set-password" element={<SetPasswordPage />} />
        <Route path="reset-password" element={<ResetPasswordPage />} />
      </Route>

      <Route
        path="bo"
        element={
          <ProtectedRoute logged={true}>
            <Account />
          </ProtectedRoute>
        }
      >
        <Route path="" element={<ProjectsPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="topics" element={<TopicsPage />} />
        <Route path="sources" element={<SourcesPage />} />
        <Route path="settings" element={<ProfilePage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="project" element={<DetailProjectPage />} />
        <Route
          path="check-project-share-code"
          element={<CheckProjectShareCodePage />}
        />
      </Route>
      <Route path="*" element={<NotFoundComponent />} />
    </Route>
  )
);

export default router;
